import { render, staticRenderFns } from "./Configure3DModel.vue?vue&type=template&id=b3556ad4"
import script from "./Configure3DModel.vue?vue&type=script&lang=js"
export * from "./Configure3DModel.vue?vue&type=script&lang=js"
import style0 from "./Configure3DModel.vue?vue&type=style&index=0&id=b3556ad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports